/* screen scale to 150* and two design layout will collage into one screen */
export const TV_MONITOR_SCALE = 3;
